import ListDetail from './ListDetail';
import Row from './Row';

ListDetail.Row = Row;

export default ListDetail;
